<template>
	<!-- argenta -->
	<div>
		<b-navbar toggleable="lg" variant="faded" type="dark" fixed="top" class="navbar-argenta">
			<b-container class="container-project">
				<b-navbar-brand :to="{name: 'index'}" class="pr-xl-5 pr-0" style="width:50%">
					<b-img class="logo" :src="require('@/assets/images/customer/argenta/logo.png')" alt=""></b-img>
				</b-navbar-brand>
				<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
				<b-collapse id="nav-collapse" is-nav>
					<b-navbar-nav class="ml-auto">
						<b-navbar-nav>
							<b-nav-item :to="{name: 'index'}" :class="{'active' : $route.name == 'index', 'item-menu-text' : true}">Mis bienes</b-nav-item>
							<b-nav-item :to="{name: 'myquotes'}" :class="{'active' : $route.name == 'myquotes', 'item-menu-text' : true}">Cotizaciones</b-nav-item>
							<b-nav-item :to="{name: 'information'}" :class="{'active' : $route.name == 'information', 'item-menu-text' : true}" :active="$route.name == 'information'">Mis Datos</b-nav-item>
							<b-nav-item class="btn-sm btn-customer" type="button" @click="logout">Cerrar sesión</b-nav-item>
						</b-navbar-nav>
					</b-navbar-nav>
				</b-collapse>
			</b-container>
		</b-navbar>
	</div>
</template>
<script>
	export default {
		name: 'NavBar',
		data(){
			return {
				logo: {
					width: "200"
				},
				menu: null,
			}
		},
		props: {
			project_id: {default: null},
		},
		mounted() {
			window.addEventListener('scroll', function() {
				if(pageYOffset < 100){
					document.querySelector('.navbar-argenta').classList.remove("fixed");
					document.querySelector('.navbar-argenta').classList.remove("navbar-light");
					document.querySelector('.navbar-argenta').classList.remove("bg-black");
					document.querySelector('.navbar-argenta').classList.remove("shadow-sm");
					document.querySelector('.navbar-argenta').classList.add("navbar-dark");
					document.querySelector('.navbar-argenta').classList.add("bg-faded");
				}else{
					document.querySelector('.navbar-argenta').classList.remove("navbar-dark");
					document.querySelector('.navbar-argenta').classList.remove("bg-faded");
					document.querySelector('.navbar-argenta').classList.add("fixed");
					document.querySelector('.navbar-argenta').classList.add("navbar-light");
					document.querySelector('.navbar-argenta').classList.add("bg-black");
					document.querySelector('.navbar-argenta').classList.add("shadow-sm")
				}
			});
		},
		methods: {
			goTo(url, params){
				this.$router.push({ name: url, params: params }).catch();
			},
			arrowRotate(menu){
				if(menu == this.menu){
					this.showSideBar = false;
					this.menu = null;
				} else {
					this.menu = menu;
					this.showSideBar = true;
				}
			},
			goToMenu(url){
				this.arrowRotate(this.menu);
				this.$router.push({ name: url}).catch();
			},
			scrollIntoView(evt) {
				evt.preventDefault()
				const href = evt.target.getAttribute('href')
				const el = href ? document.querySelector(href) : null
				if (el) {
					window.scroll({
						top: el.offsetTop,
						behavior: 'smooth'
					});
				}
			},
			logout(){
				this.$auth.logout({
					redirect: '/login',
					success: function (msg) {
						console.error("LOGIN:",msg);
					},
				});
			}
		},
	}
</script>
<style>
	.logo{
		width: 150px;
		margin-left: 45px;
	}
	.bg-black {
		background-color: rgb(28, 28, 28) !important;
	}
	.bg-black a{
		color: #FFF !important;
	}
</style>
